export default __webpack_public_path__ + "static/Saira-Black-b544e903fa40255b23b41fbce7738416.woff2";